export const PUBLISHER_FROZEN_BANNER_MESSAGE =
  'This publisher account has been frozen.';

export const PUBLISHER_FROZEN_SUPPORT_TOOLTIP =
  'Contact support if you believe this is a mistake.';

export const PUBLISHER_FROZEN_ACTION_TOOLTIP =
  'This publisher account is frozen. Contact support if you believe this is a mistake.';

export const PUBLISHER_FROZEN_NEW_VERSION_MESSAGE =
  'This publisher account is frozen. New versions cannot be uploaded.';
